<template>
  <div class="device_task">
    <div class="logo">
      <span
        href="#"
        class="simple-text"
      >
        <div class="logo-img">
          <img src="/web/img/logo.png" alt="" >
        </div>

        {{ translate('manage') }}

        <div
          v-if="path !== 'main'"
          style="float:right"
        >
          <a
            class="device-tasks_content_back"
            @click="back"
          >
            {{ translate('main menu') }}
          </a>
        </div>
      </span>
    </div>
    <div class="content">
      <div v-if="path === 'main'">
        <div class="col-md-12 center">
          <button
            type="submit"
            class="btn btn-info btn-fill btn-wd"
            @click="update"
          >
            {{ translate('task.update') }}
          </button>
        </div>
        <div class="center">
          <button
            type="submit"
            class="btn btn-link"
            @click="close"
          >
            {{ translate('close_modal') }}
          </button>
        </div>
      </div>
      <template v-if="path === 'update'">
        <device-update
          :list-device="listDevice"
          @close="close"
        />
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DeviceManage',
  props: ['listDevice'],
  data () {
    return {
      path: 'main',
      opt_group: [],
      group: []
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    update () {
      this.path = 'update'
    },
    back () {
      this.path = 'main'
    }
  }
}
</script>
